import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-inspect",
  "use": "menu-inspect-usage",
  "viewBox": "0 0 23.03 28",
  "content": "<symbol viewBox=\"0 0 23.03 28\" id=\"menu-inspect\"><title>资源 15</title><g id=\"menu-inspect_图层_2\" data-name=\"图层 2\"><g id=\"menu-inspect_图层_1-2\" data-name=\"图层 1\"><path d=\"M23,4.06H21.87a16.22,16.22,0,0,1-5.21-1.14A24.32,24.32,0,0,1,12.19.5L11.5,0l-.68.5a22.42,22.42,0,0,1-4.46,2.4A16.29,16.29,0,0,1,1.15,4H0V15.84C0,21.75,7.49,28,11.52,28S23,21.75,23,15.84ZM14.53,15.51H13v2.26a1.51,1.51,0,0,1-3,0V15.51H8.5a1.51,1.51,0,0,1,0-3H10V10.23a1.51,1.51,0,1,1,3,0v2.26h1.51a1.51,1.51,0,1,1,0,3Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-inspect.svg
// module id = 2Idb
// module chunks = 264